import { render, staticRenderFns } from "./SpecifySurgeryPrice.vue?vue&type=template&id=9fe2add2&scoped=true"
import script from "./SpecifySurgeryPrice.vue?vue&type=script&lang=js"
export * from "./SpecifySurgeryPrice.vue?vue&type=script&lang=js"
import style0 from "./SpecifySurgeryPrice.vue?vue&type=style&index=0&id=9fe2add2&prod&scoped=true&lang=css"
import style1 from "./SpecifySurgeryPrice.vue?vue&type=style&index=1&id=9fe2add2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe2add2",
  null
  
)

export default component.exports